import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_GENERAL_COMMENT' as const;
export { ExportStatus as Status };
